function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4 4a2 2 0 00-2 2v10a2 2 0 002 2h1.5a.5.5 0 01.5.5v2.46a.5.5 0 00.812.39l4.051-3.24a.5.5 0 01.312-.11H20a2 2 0 002-2V6a2 2 0 00-2-2H4z",
  fill: "#fff"
});

var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref);
};

export default SvgChat;